import { createSerializeWire, } from '../Serializable';
import { BinaryReader } from '../utils';
export class ContractParameterBase {
    constructor() {
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
    }
    static deserializeContractParameterBaseWireBase({ reader }) {
        const type = reader.readUInt8();
        return { type };
    }
    static deserializeWireBase(_options) {
        throw new Error('Not Implemented');
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    asBuffer() {
        throw new Error('Unimplemented.');
    }
    asBoolean() {
        return this.asBuffer().some((value) => value !== 0);
    }
    serializeWireBase(writer) {
        writer.writeUInt8(this.type);
    }
    serializeJSON(_context) {
        throw new Error('Not Implemented');
    }
}

//# sourceMappingURL=ContractParameterBase.js.map
